/**
 * On-screen keyboard detection for phones. The app resizes when the keyboard opens
 * (adjustResize / interactive-widget=resizes-content), so a typing field plus a much shorter
 * window means the keyboard is up. `kb-open` on <html> lets the tab bar step aside, so bars such as
 * Charge and page footers sit right on top of the keyboard.
 */
let base = 0;
let baseWidth = 0;

function editable(el: Element | null) {
  if (!el) return false;
  const t = el.tagName;
  if (t === 'TEXTAREA' || (el as HTMLElement).isContentEditable) return true;
  if (t !== 'INPUT') return false;
  return !['button', 'checkbox', 'radio', 'range', 'submit', 'reset', 'file', 'color'].includes((el as HTMLInputElement).type);
}

function update() {
  const h = window.visualViewport?.height ?? window.innerHeight;
  const w = window.innerWidth;
  if (w !== baseWidth) { baseWidth = w; base = h; } // rotation: start over
  if (h > base) base = h;
  const open = editable(document.activeElement) && h < base - 120;
  document.documentElement.classList.toggle('kb-open', open);
}

export function watchKeyboard() {
  update();
  window.visualViewport?.addEventListener('resize', update);
  window.addEventListener('resize', update);
  document.addEventListener('focusin', () => setTimeout(update, 50));
  document.addEventListener('focusout', () => setTimeout(update, 50));
}
